import React from 'react';
import { CSSTransition } from 'react-transition-group';
import './css/loadingspinner.css';

function LoadingSpinner(props) {
  return (
    <CSSTransition
      in={props.loading}
      timeout={300}
      classNames="loading"
      unmountOnExit
    >
      <div className="spinner_container" style={props.style}>
        <div className="spinner-border text-light" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </CSSTransition>
  );
}

export default LoadingSpinner;